import React from 'react'
import {useEffect, useState} from 'react'
import Button from '../Button'
import {numbersList} from '../../data/numbersList'
import FromToInput from '../FromToInput'
import usePost from '../../hooks/usePost'
import { kycHeatList } from '../../data/portalFormListData'
import chevronDown from '../../assets/icons/chevron-down-big-white.svg'
import SelectInput from '../SelectInput'
import TextInput from '../TextInput'
import { isDealPreAvinode } from '../../utilities/settings'
import { currencyList } from '../../data/currencyList'
import format from "date-fns/format"
import formatISO from "date-fns/formatISO"
import {getDate} from '../../utilities/date'
import PortalSalesStageBasedCtas from './PortalSalesStageBasedCtas'
import PortalQuoteOptions from './PortalQuoteOptions'
import DatePickerInput from '../DatePickerInput'
import TimePickerInput from '../TimePickerInput'
import PortalSubTitleBar from './PortalSubTitleBar'
import LoadingOverlay from '../LoadingOverlay'
import TextAreaInput from '../TextAreaInput'
import CloseCross from '../CloseCross'

const PortalSalesDetails = ({deal, legs, onDeleteLeg}) => {
    

    const {sending, returnMessage, postData} = usePost()
    const [legData, setLegData] = useState({})
    const [paramLegs, setParamLegs] = useState(legs)
    const [selectedKycHeat, setSelectedKycHeat] = useState('')
    const [selectedPrefCurrency, setSelectedPrefCurrency] = useState('')
    const [selMovida, setSelMovida] = useState('')
    const [numPets, setNumPets] = useState(0)
    const [currentNotes, setCurrentNotes] = useState('')
    const [contractName, setContractName] = useState('')
    
    const [didSetDeal, setDidSetDeal] = useState(false)

    const [showResultOptions, setShowResultOptions] = useState(false)

    const [firstLeg, setFirstLeg] = useState(null)

    useEffect(() => {
        if(legs) {
        const tmpLegs = legs.map((leg, index) => {
            return {
                id : leg.id,
                airport_From : leg.airport_From,
                airport_To : leg.airport_To,
                number_of_Bags : leg.number_of_Bags,
                number_of_Passengers : leg.number_of_Passengers,
                Leg_Date_and_Time: leg.leg_Date_and_Time,
                daM_Ref: leg.daM_Ref
            }
        })

        //console.log(tmpLegs)
        for(let i = 0; i < tmpLegs.length; i++){
            const l = tmpLegs[i]
            legData[l.id] = l
        }
        //console.log(legData)
        
        setParamLegs(legs)

        if(paramLegs && !isDealPreAvinode(deal)) { 
            const theFirstLeg = paramLegs.sort((a, b) => {return a.leg_Number < b.leg_Number ? -1 : 1})[0]
            setFirstLeg(theFirstLeg)
        }
    }
    }, [legs, paramLegs, legData])

    useEffect(() => {
        if(deal && !didSetDeal) {
            setSelectedKycHeat(deal.kyC_Heat)
            setSelectedPrefCurrency(deal.preferred_Currency)
            setSelMovida(deal.show_MOVIDA_in_Quote)
            setNumPets(deal.number_of_Pets ?? 0)
            setCurrentNotes(deal.notes_on_Flight)
            setContractName(deal.contract_Display_Name)

            setDidSetDeal(true)
        }
    }, [deal])

    const saveLegs = () => {
        let formData = {}

        let updatedLegData = []

        for(const key of Object.keys(legData)){
            updatedLegData.push(legData[key])
        }

        formData = {
            legs: updatedLegData,
            dealId: deal.id
        }

        postData(formData, '/api/portal/update-deal-legs', 1000)
    }

    
    const updateLegHandler = (leg, key, e) => {
        legData[leg.id][key] = e.target.value
    }

    const updateLegDateHandler = (leg, key, e) => {
        const currentDate = new Date(leg.leg_Date_and_Time)
        //console.log(leg.leg_Date_and_Time)
        switch(key){
            case 'date': {
                const newDateStr = e.target.value
                const hours = currentDate.getHours()
                const minutes = currentDate.getMinutes()
                const seconds = currentDate.getSeconds() // Optional, for full precision
                const milliseconds = currentDate.getMilliseconds()

                // Parse the new date string
                const [year, month, day] = newDateStr.split("-").map(Number)

                // Create a new Date using new date and original time
                const newDateTime = new Date(year, month - 1, day, hours, minutes, seconds, milliseconds)
                legData[leg.id]['Leg_Date_and_Time'] = newDateTime.toJSON()//format(newDateTime, "yyyy-MM-dd'T'HH:mm+00:00")
            }
                break;
            case 'time': {
                // console.log(e.target.value)
                // console.log(typeof(e.target.value))
                const newTime = e.target.value
                const year = currentDate.getFullYear()
                const month = currentDate.getMonth() // Note: 0-based
                const day = currentDate.getDate()

                // Split the time string into hours and minutes
                const [hours, minutes] = newTime.split(":").map(Number)

                // Construct a new Date object with the new time
                const newDateTime = new Date(year, month, day, hours, minutes)
                //console.log(format(newDateTime, "yyyy-MM-dd'T'HH:mm+00:00"))
                
                legData[leg.id]['Leg_Date_and_Time'] = newDateTime.toJSON()//format(newDateTime, "yyyy-MM-dd'T'HH:mm+00:00")
                //leg.leg_Date_and_Time = format(newDateTime, "yyyy-MM-dd'T'HH:mm+00:00")
                }
                break;

        }
        
    }

    const updateDeal = () => {
        let formData = {}

        formData = {
            dealId: deal.id,
            KYC_Heat: selectedKycHeat,
            Preferred_Currency: selectedPrefCurrency,
            Show_MOVIDA_in_Quote: selMovida,
            Number_of_Pets: numPets,
            Notes_on_Flight: currentNotes,
            Contract_Display_Name: contractName
        }

        postData(formData, '/api/portal/update-deal')

        //console.log(formData)
    }

    const onShowOptionsHandler = () => {
        setShowResultOptions(!showResultOptions)
    }

    return (deal && 
        <>
        <div className='deal_details_form' key='sect-sales-deal'>
            <div>
                <div className='formRow'>
                    <label>Date opened:</label> {format(new Date(deal.date_Opened), 'dd/MM/yyyy')}
                </div>
                <div className='formRow'>
                    <label>Preferred currency:</label>
                    
                    <SelectInput
                        options={currencyList}
                        value={(value) => setSelectedPrefCurrency(value)}
                        defaultValue={selectedPrefCurrency}
                        chevron={chevronDown}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    />

                    {/* <input type='text' defaultValue={deal.preferred_Currency} /> */}
                </div>
                <div className='formRow'>
                    <label>KYC heat:</label>
                    <SelectInput
                            value={(value) => setSelectedKycHeat(value)}
                            options={kycHeatList}
                            label=''
                            required
                            chevron={chevronDown}
                            defaultValue={deal.kyC_Heat}
                            classNames={['select-input--full select-input--form']}
                        />
                </div>
                <div className='formRow'>
                    <label>Show Movida</label> <input type='checkbox' 
                        onChange={(e) => setSelMovida(e.target.checked)}
                        defaultChecked={deal.show_MOVIDA_in_Quote} 
                        name='show_MOVIDA_in_Quote' />
                </div>
                <div className='formRow'>
                    <label>Full name</label> {deal.leadFullName} 
                </div>
                <div className='formRow'>
                    <label>Contract name:</label> 
                    <TextInput 
                        defaultValue={contractName}
                        label=''
                        value={(fromValue) => setContractName(fromValue)}
                    />
                </div>                
            </div>
            <div>
                <div className='formRow'>
                    <label>Tenant:</label> {deal.tenantID}
                </div>
                <div className='formRow'>
                    <label>Service:</label> {deal.service}
                </div>
                <div className='formRow'>
                    <label>Trip type:</label> {paramLegs.length === 1 ? 'Single' : paramLegs.length === 2 ? 'Return' : 'Multi-leg'}
                </div>
                <div className='formRow'>
                    <label>Notes:</label>
                    <TextAreaInput
                        defaultValue={deal.notes_on_Flight}
                        value={(fromValue) => setCurrentNotes(fromValue)}
                        label=''
                    />
                </div>
                <div className='formRow'>
                    <label>Num Pets:</label> 
                    <fieldset class="fieldset fieldset--margin-bottom">
                        <div class="text-input text-input--margin-bottom">
                            <input type="text" autocomplete="on" class="text-input__input" defaultValue={deal.number_of_Pets ?? 0}  onChange={(e) => setNumPets(parseInt(e.target.value))} />
                            <label class="label label--minimised"></label>
                        </div>
                    </fieldset>
                </div>
                <div className='formRow'>
                    <label>SHYF number:</label> {deal.shyF_No}
                </div>
            </div>
            
        </div>
        <div>
            <Button classNames={['button--tertiary']} onClick={() => updateDeal()}>Save changes</Button>
        </div>
        <div className='portal-details__legs-edit' key='sect-sales-legs'>
            
            <div className={'gold_divider'}></div>

            {paramLegs && isDealPreAvinode(deal) && paramLegs.sort((a, b) => {return a.leg_Number < b.leg_Number ? -1 : 1}).map((leg, index) => {
                return (
                    <div className={'leg-form'} key={leg.id}>
                        <div className='leg-header'>
                            Leg {index+1} - {leg.airport_From} - {leg.airport_To}
                        </div>
                        <div className='formRow'>
                            <label>From:</label> 
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input type="text" class="text-input__input" defaultValue={leg.airport_From} onChange={(v) => updateLegHandler(leg, 'airport_From', v)} />
                                    <label class="label label--minimised"></label>
                                </div>
                            </fieldset>
                            
                        </div>
                        <div className='formRow'>
                            <label>To:</label> 
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input type="text" class="text-input__input" defaultValue={leg.airport_To} onChange={(v) => updateLegHandler(leg, 'airport_To', v)} />
                                    <label class="label label--minimised"></label>
                                </div>
                            </fieldset>
                        </div>
                        <div className='formRow'>
                            <label>Date/Time:</label> 
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input type="date" defaultValue={format(new Date(leg.leg_Date_and_Time), 'yyyy-MM-dd')} onChange={(v) => updateLegDateHandler(leg, 'date', v)} className='text-input__input' />
                                    <label class="label label--minimised"></label>
                                </div>
                                <div class="text-input text-input--margin-bottom">
                                    <input type="time" defaultValue={format(new Date(leg.leg_Date_and_Time), 'HH:mm')} onChange={(v) => updateLegDateHandler(leg, 'time', v)} className='text-input__input' />
                                    <label class="label label--minimised"></label>
                                </div>
                            </fieldset>                     
                        </div>
                        <div className='formRow'>
                            <label>Num Pax:</label> 
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input type="text" autocomplete="on" class="text-input__input" defaultValue={leg.number_of_Passengers} onChange={(v) => updateLegHandler(leg, 'number_of_Passengers', v)}/>
                                    <label class="label label--minimised"></label>
                                </div>
                            </fieldset>
                        </div>
                        <div className='formRow'>
                            <label>Num Bags:</label> 
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input type="text" autocomplete="on" class="text-input__input" defaultValue={leg.number_of_Bags} onChange={(v) => updateLegHandler(leg, 'number_of_Bags', v)}/>
                                    <label class="label label--minimised"></label>
                                </div>
                            </fieldset>
                        </div>
                        {paramLegs.length > 1 && 
                        <div className='formRow'>
                            <Button classNames={['button--tertiary']} onClick={() => onDeleteLeg(leg)}>Delete</Button>
                        </div>
                        }
                    </div>
                )
            })} 
            {isDealPreAvinode(deal) && 
                <Button  classNames={['button--tertiary']} onClick={saveLegs}>Update legs</Button>  
            }

            {paramLegs && !isDealPreAvinode(deal) &&
                <>
                <div className='deal_details_form'>
                    <div>
                        {paramLegs && !isDealPreAvinode(deal) && paramLegs.sort((a, b) => {return a.leg_Number < b.leg_Number ? -1 : 1}).map((leg, index) => {
                            return (
                                <>
                                <div className='formRow'>
                                    <strong><em>Leg {index+1}</em></strong>
                                </div>
                                <div className='formRow'>
                                    <label>From:</label> {leg.airport_From}
                                </div>
                                <div className='formRow'>
                                    <label>To:</label> {leg.airport_To}
                                </div>
                                <div className='formRow'>
                                    <label>Date:</label> {format(new Date(leg.leg_Date_and_Time), 'dd/MM/yyyy HH:mm')}
                                </div>
                                {(deal.leg_1_Date_of_Arrival && index === 0) && 
                                    <div className='formRow'>
                                        <label>Arrival date/time:</label> {format(new Date(deal.leg_1_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_1_Time_of_Arrival}
                                    </div>
                                }
                                {(deal.leg_2_Date_of_Arrival && index === 1) && 
                                    <div className='formRow'>
                                        <label>Arrival date/time:</label> {format(new Date(deal.leg_2_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_2_Time_of_Arrival}
                                    </div>
                                }
                                <div className='formRow'>
                                    <label>Pax:</label> {leg.number_of_Passengers}
                                </div>
                                <div className='formRow'>
                                    <label>Bags:</label> {leg.number_of_Bags}
                                </div>
                                </>
                            )
                        })} 
                    </div>
                </div>
                </>
            }
            
        </div>

        {(deal && showResultOptions) && 
            <>
                <div className='portal__quote-options-close-wrapper'>
                    <CloseCross colour={'white'} onClick={() => setShowResultOptions(false)} />
                </div>
                <PortalQuoteOptions 
                    deal={deal}
                    onClose={() => setShowResultOptions(false)}
                    onDidReserveResult={() => setShowResultOptions(false)}
                />
            </>
        }

        {(deal && firstLeg) && 
            <PortalSalesStageBasedCtas 
                deal={deal} 
                firstLeg={firstLeg}
                onShowOptions={() => onShowOptionsHandler()}
            />
        }

        {sending && 
            <LoadingOverlay />
        }
        </>
    )
}

export default PortalSalesDetails